import { render, staticRenderFns } from "./info-sidebar.vue?vue&type=template&id=2b1fbc49&scoped=true&"
import script from "./info-sidebar.vue?vue&type=script&lang=js&"
export * from "./info-sidebar.vue?vue&type=script&lang=js&"
import style0 from "./info-sidebar.vue?vue&type=style&index=0&id=2b1fbc49&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b1fbc49",
  null
  
)

export default component.exports